import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from './auth';

export const offerStore = defineStore('offer-store', {
    state: () => {
        return {
            allOffers: null,
        };
    },
    getters: {
        offers(state) {
            return state.allOffers;
        },
    },

    actions: {
        async fetchAllOffers() {
            try {
                const response = await axios.get(
                    process.env.VUE_APP_API_BASE_URL + 'applicants/me/offers',
                    authStore().authConfig
                );
                this.allOffers = response.data;
                return true;
            } catch (err) {
                this.allOffers = [];
                console.error('error loading offers: ', err);
                return err;
            }
        },
    },
});
